import { inmersysVrApi, inmersysXRApiLocal, isConnected } from "./api";
import { Endpoints } from "./enpoints";

const responseAxios = (status = 0, msg = "", payload = null) => {
	return {
		status,
		msg,
		payload,
	};
};

export const trainigonGetAllResponsesByProjectId = async (proyectId) => {
	try {
		if (isConnected) {
			const data = await inmersysVrApi.get(Endpoints.project.allresponsesTrainingByProyectid + "?projectId=" + proyectId);
			return responseAxios(data.data.status, data.data.message, { ...data.data });
		} else {
			const data = await inmersysVrApi.get("training/all");
			return responseAxios(data.data.status, data.data.message, { ...data.data });
		}
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const getAllResponsesByProjectIdLocal = async () => {
	try {
		const data = await inmersysXRApiLocal.get("training/all");
		return responseAxios(data.data.status, data.data.message, { ...data.data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const updateApiWhitLocalResponses = async (payload) => {
	try {
		const data = await inmersysVrApi.post(Endpoints.responses.addManyTraining, {
			responses: payload,
		});
		return responseAxios(data.data.status, data.data.message, { ...data.data });
	} catch (error) {
		console.log("error", error);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
// //////////////

export const trainingOnGetDetailProyectsByEnterpiseId = async (id) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.project.trainingDetailsProyecstbyEnterpiseId + id, {});
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
